import { createSlice } from "@reduxjs/toolkit";

const wsSlice = createSlice({
  name: "ws",
  initialState: {
    data: [], // 改為陣列，存放完整資料
    history: [],
  },
  reducers: {
    // 初始化完整資料
    setInitialData: (state, action) => {
      state.data = action.payload; // 完整陣列
    },

    // 更新單筆資料
    updateSingleItem: (state, action) => {
      const updatedItem = action.payload;
      const existingIndex = state.data.findIndex(
        (item) => item.id === updatedItem.id
      );

      if (existingIndex !== -1) {
        // 更新現有項目
        state.data[existingIndex] = updatedItem;
      } else {
        // 新增項目（如果 ID 不存在）
        state.data.push(updatedItem);
      }

      // 記錄歷史
      state.history.unshift(updatedItem);
      if (state.history.length > 50) {
        state.history.pop();
      }
    },

    clearWsData: (state) => {
      state.data = [];
      state.history = [];
    },
  },
});

export const { setInitialData, updateSingleItem, clearWsData } =
  wsSlice.actions;
export const selectWsData = (state) => state.ws.data;
export const selectWsHistory = (state) => state.ws.history;
export default wsSlice.reducer;
